import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { httpAPI_CON001, httpAPI_PRE001 } from "./api/request";
import { infoHeadTitleList, searchFormList } from "./parts";
import { ContractorList } from "../../type/apiType/IAPI_CON001";
import TkButton from "../../components/atoms/TkButton";
import TkCorporateSearchModal from "../../components/molecules/TkCorporateSearchModal";
import { Box, IconButton, InputAdornment, Link } from "@mui/material";
import { TkGetCode } from "../../utils/TkGetCode";
import { submitWay } from "../../assets/data/Constants";
import TkDataTable from "../../components/molecules/TkDataTable";
import { GlobalContext } from "../../context/globalContext";
import TkLabelText from "../../components/atoms/TkLabelText";
import { ClearIcon } from "@mui/x-date-pickers";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import _ from "lodash";
import { BusinessContext } from "../../context/businessContext";
import { IAPI_PRE001_Request } from "../../type/apiType";
import { changeAmountFormat } from "../../utils/useTools";

/**
 * SCRW080001 掛金届出状況一覧
 * @return SCRW080001 掛金届出状況一覧
 */
const SCRW080001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.searchForPremium;
  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [corporateInfoTableList, setCorporateInfoTableList] = useState<any>([]);
  const [corporateList, setCorporateList] = useState<ContractorList[]>([]);
  const [corpInfo, setCorpInfo] = useState<ContractorList>();

  useEffect(() => {
    let resArr = searchList.current;
    for (let i in context) {
      let targetObj = resArr.find((item: any) => item.keyword === i)!;

      targetObj &&
        (targetObj.wantToSetValue = context[i as keyof typeof context]);
    }
    setStateSearchList([...resArr]);

    if (context) {
      if (context?.contractorNo) {
        setCorpInfo({
          contractorNo: context?.contractorNo,
          corpName: context?.contractorName,
        });
      }
      let param = {
        contractorNo: context?.contractorNo,
        corpApplyKbn: context?.corpApplyKbn,
        lastApplyStatus: context?.lastApplyStatus,
        receiveStatus: context?.receiveStatus,
        surchargeReceiveStatus: context?.surchargeReceiveStatus,
      };
      handleSearch(param);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = async (data?: any) => {
    const param: IAPI_PRE001_Request = {
      contractorNo: corpInfo?.contractorNo,
      ...data,
    };
    // 掛金届出状況一覧表示API 呼び出し
    try {
      const res = await httpAPI_PRE001({
        ...param,
      });

      setCorporateInfoTableList([]);

      if (res.resultCd === "I0000") {
        const infoBodyList = res.premiumApplyStatusList?.map((item) => [
          {
            children: (
              <Link
                data-testid="nameLink"
                onClick={() =>
                  clickLink(res.premiumApplyStatusList && item.contractorNo)
                }
              >
                {(item.contractorNo ?? "") + ":" + (item.contractorName ?? "")}
              </Link>
            ),
            forSort: item.contractorNo,
          },
          {
            children: TkGetCode(submitWay, item.corpApplyKbn),
            forSort: item.corpApplyKbn,
          },
          {
            children: item.lastApplyStatus,
            forSort: item.lastApplyStatus,
          },
          {
            children: changeAmountFormat(item.receiveInvoiceAmt ?? 0),
            forSort: item.receiveInvoiceAmt,
            align: "right",
          },
          {
            children: item.receiveStatus,
            forSort: item.receiveStatus,
          },
          {
            children: item.reminderCount,
            forSort: item.reminderCount,
            align: "right",
          },
          {
            children: changeAmountFormat(item.surchargeReceiveInvoiceAmt ?? 0),
            forSort: item.surchargeReceiveInvoiceAmt,
            align: "right",
          },
          {
            children: item.surchargeReceiveStatus,
            forSort: item.surchargeReceiveStatus,
          },
        ]);
        setCorporateInfoTableList(infoBodyList ?? []);

        setBusinessState({
          searchForPremium: {
            ...param,
            contractorName: corpInfo?.corpName ?? context?.contractorName,
          },
        });
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const clickLink = (contractorNo: any) => {
    navigate("/SCRW080002", { state: { contractorNo: contractorNo } });
  };
  const serchDialogOpen = () => {
    setCorporateList([]);
    setOpenSuccess(true);
  };

  const handleClose = () => {
    setOpenSuccess(false);
  };

  const handleChangeSearchData = async (e: any) => {
    try {
      const res = await httpAPI_CON001({
        contractorNo: e.contractorNo ? e.contractorNo : "",
        corpName: e.corpName ? e.corpName : "",
        prefectureCd: e.prefectureCd ? e.prefectureCd : "",
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setCorporateList(res.contractorList!);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setCorporateList([]);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = (e: any) => {
    if (!e) return;
    setCorpInfo(e);
    setOpenSuccess(false);
  };

  const handleClear = () => {
    setCorpInfo(undefined);
  };

  return (
    <Box data-testid="SCRW080001PageForTest" className="tkSCRW080001">
      <Box className="headerList">
        <Box className="headerListItem">
          <Box className="btnInput">
            <TkLabelText
              label="共済契約者"
              variant="standard"
              fullWidth={false}
              wantToSetValue={
                corpInfo
                  ? (corpInfo?.contractorNo ?? "") +
                    ":" +
                    (corpInfo?.corpName ?? "")
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClear}
                      edge="end"
                      sx={{ padding: 0.5, marginRight: 0.2 }}
                    >
                      <ClearIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              disabled
            />
            <TkButton onClick={serchDialogOpen}>法人検索</TkButton>
          </Box>
        </Box>
        <TkSearchForm
          listData={stateSearchList}
          buttonText="表示"
          onSearch={handleSearch}
        />
      </Box>

      {/* 契約者掛金届出状況一覧表示 */}
      <TkDataTable
        headList={infoHeadTitleList}
        bodyList={corporateInfoTableList}
        count={corporateInfoTableList.length}
        defaultRowsPerPage={10}
        pagin
        showUnit
      />

      {/* 法人検索ダイアログ表示 */}
      <TkCorporateSearchModal
        open={openSuccess}
        listData={corporateList}
        onClose={handleClose}
        onChangeSearchData={handleChangeSearchData}
        onSave={handleSave}
      />
    </Box>
  );
};

export default SCRW080001;
